import React from 'react';
import { Box, Skeleton, Container, Grid, useMediaQuery } from '@mui/material';
import { styled, keyframes } from '@mui/system';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const SectionWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
   animation: `${fadeIn} 1s ease-in-out`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));


const ContentSectionSkeleton = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <SectionWrapper>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={{ padding: 2 }}>
            {isMobile ? (
                <>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Skeleton variant="text" width="80%" sx={{ marginBottom: 1 }} />
                    <Skeleton variant="rectangular" width="50%" height={170} />
                      </Box>
                <Skeleton variant="text" width="80%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="70%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="50%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="70%" sx={{ margin: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ margin: 2 }} />
                <Skeleton variant="text" width="50%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="80%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="70%" sx={{ margin: 2 }} />
                <Skeleton variant="text" width="50%" sx={{ margin: 2 }} />
            </>
            ) : (
              <>
                <Skeleton variant="text" width="60%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="80%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="40%" sx={{ marginBottom: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ marginBottom: 2 }} />
                <Skeleton variant="text" width="90%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="70%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ marginBottom: 2 }} />
                <Skeleton variant="text" width="90%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="70%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ marginBottom: 2 }} />
                <Skeleton variant="text" width="90%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="70%" sx={{ marginBottom: 1 }} />
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ marginBottom: 2 }} />
                <Skeleton variant="text" width="50%" />
              </>
            )}
          </Box>
        </Grid>
        {!isMobile && (
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', height: '100%' }}>
              <Skeleton variant="rectangular" width="100%" height={300} />
            </Box>
          </Grid>
        )}
      </Grid>
    </SectionWrapper>
  );
};

export default ContentSectionSkeleton;